<template>
  <div class="feature-tab">
    <p class="text-2xl font-semibold">How to play</p>
    <hr>

    <br>
    <div class="p-4">
    <p class="text-2xl font-semibold">Introduction</p>
    <p class="text-lg">Card Quest is a Card Collection Game!</p>
    <p class="text-lg">Collect Cards, build your Deck, and go on Adventures!</p>
    <p class="text-lg">In this game you don't play against another player, or an AI. You play against the Level.</p>
    <p class="text-lg">The Level plays cards at certain turns. These cards are known beforehand so you can build
      your deck around it.</p>

    <br>
    <p class="text-2xl font-semibold">Adventure</p>
    <p class="text-lg">Take your Deck and go on an Adventure.</p>
    <p class="text-lg">Battle your way through different Levels and defeat your enemies!</p>
    <br>
    <p class="text-lg">Whenever you perform an Action, the turn increases.</p>
    <p class="text-lg">The Level will Play certain Cards at certain turns</p>
    <br>
    <p class="text-lg">You can Play a card, to place it on the Field.</p>
    <p class="text-lg">Cards in the Field can be Tapped to interact with them.</p>
    <p class="text-lg">Cards can have costs to Play them, or Resources when they leave the Field (or both).</p>
    <p class="text-lg">You can use these Resources to upgrade your Tools and Weapons, or Play Action cards!</p>
    <br>
    <p class="text-lg">When you complete a Level, you gain some Cards to further improve your deck!</p>
    <p class="text-lg">More difficult Levels award rarer and better Cards.</p>

    <br>
    <p class="text-2xl font-semibold">Card Collection</p>
    <p class="text-lg">Here you can view your collected Cards. Build your Decks and save them using the Deck
      Presets.</p>
    <p class="text-lg">The max amount of a single card is 10. You need at least 15 cards in your deck to start a
      level.</p>
    <p class="text-lg">You can share your Decks with other players by importing and exporting their codes!</p>

    <br>
    <p class="text-2xl font-semibold">Achievements</p>
    <p class="text-lg">If you've done impressive things, they will show up here.</p>

    <br>
    <p class="text-2xl font-semibold">Quick tips</p>
    <p class="text-lg">Check the settings for things you want to toggle.</p>
    <p class="text-lg">Preview the Adventure before taking it on to see which cards will be played.</p>
    <p class="text-lg">Spend your money on starting stats to skip the early game (if you can afford it).</p>

    <br>
    <p class="text-2xl font-semibold">Hotkeys</p>
    <p class="text-lg">Shift + Click Cards to discard them</p>
    <p class="text-lg">1-9 to Play Cards</p>
    <p class="text-lg">Ctrl + 1-9 to Tap Cards</p>
    <p class="text-lg">Shift + 1-9 to Discard Cards</p>
    <p class="text-lg">D to Draw</p>
    <p class="text-lg">W to Wait a turn</p>
    <p class="text-lg">Q to instantly forfeit</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "cq-how-to-play",

}
</script>

<style scoped>
p {
  @apply text-white;
}
</style>
